import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import Icons from '../../../utils/Icons';

const IconComponent = ({ icon, color = 'white', height = 24, inputStyle }) => {
  // Ensure the provided icon exists in the Icons object
  const iconName = Icons[icon] || icon; // Fallback to raw string if key not found

  return <Icon icon={iconName} height={height} style={{ color }} className={inputStyle} />;
};

IconComponent.propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string, // Optional with default 'white'
  height: PropTypes.number, // Optional with default 24
  inputStyle: PropTypes.string,
};

export default IconComponent;
